
import React from 'react'


const Arrival = () => {
  return (
    <div className="mx-auto py-5 px-4 w-full max-w-7xl bg-white">
      <div className="mx-auto max-w-md md:max-w-none grid md:grid-rows-2 grid-cols-1 md:grid-cols-2 md:grid-flow-col gap-5">

        {/* :CATEGORY 1 -> LEFT TOP */}
        <div className="md:row-span-1 relative group shadow-sm rounded bg-gradient-to-r from-white lg:from-gray-100 to-gray-100 overflow-hidden hover:shadow-lg hover:from-gray-50 hover:to-gray-50">
          <a href="#categoryLink" className="px-4 h-full flex flex-col justify-center items-start">
            {/* ::Background Image */}
            <img src="https://fancytailwind.com/static/tv1-transparent-6f91c509ad799314f2cceae5e369167a.png" alt="" className="absolute bottom-0 right-5 h-full opacity-50 lg:opacity-100" />
            {/* ::Category Details */}
            <div className="relative py-8 h-full bg-gradient-to-r from-white lg:from-transparent via-white lg:via-transparent to-transparent">
              {/* :::name */}
              <h3 className="text-base text-gray-400 font-bold">#Entertainment</h3>
              {/* :::title */}
              <p className="mt-1 text-lg sm:text-xl lg:text-2xl text-gray-700 font-bold">
                <span className="block">Discover Our</span>
                <span className="block">TV & Audio Selection</span>
              </p>
            </div>
          </a>
        </div>
        
        
        {/* :CATEGORY 2 -> LEFT BOTTOM */}
        <div className="md:row-span-1 relative group shadow-sm rounded bg-gradient-to-l from-white lg:from-gray-100 to-gray-100 overflow-hidden hover:shadow-lg hover:from-gray-50 hover:to-gray-50">
          <a href="#categoryLink" className="px-4 h-full flex justify-end">
            {/* ::Background Image */}
            <img src="https://fancytailwind.com/static/armchair3-transparent-6895e0d91e1c3d57e81ce1e2e9fa90ce.png" alt="" className="absolute bottom-0 left-5 h-full opacity-50 lg:opacity-100" />
            {/* ::Category Details */}
            <div className="relative py-8 h-full bg-gradient-to-l from-white lg:from-transparent via-white lg:via-transparent to-transparent">
              {/* :::name */}
              <h3 className="text-right text-base text-gray-400 font-bold">#Relax</h3>
              {/* :::title */}
              <p className="mt-1 text-right text-lg sm:text-xl lg:text-2xl text-gray-700 font-bold">
                <span className="block">Make your Living Room</span>
                <span className="block">More Comfortable</span>
              </p>
            </div>
          </a>
        </div>


        {/* :CATEGORY 3 -> RIGHT */}
        <div className="md:row-span-2 md:col-span-2 relative group shadow-sm rounded bg-gradient-to-r from-white lg:from-gray-100 to-gray-100 overflow-hidden hover:shadow-lg hover:from-gray-50 hover:to-gray-50">
          <a href="#categoryLink" className="px-4 h-full flex flex-col justify-center items-start">
            {/* ::Background Image */}
            <img src="https://fancytailwind.com/static/chair2-transparent-e1321d919ed9693d44d7fff06f33498c.png" alt="" className="absolute bottom-0 right-0 p-5 h-full md:h-4/5 lg:h-full opacity-50 lg:opacity-100" />
            {/* ::Category Details */}
            <div className="relative py-8 h-full bg-gradient-to-r from-white lg:from-transparent via-white lg:via-transparent to-transparent">
              {/* :::name */}
              <h3 className="text-base text-gray-400 font-bold">#House</h3>
              {/* :::title */}
              <p className="mt-1 text-lg sm:text-xl lg:text-2xl text-gray-700 font-bold">
                <span className="block">Express Your Life</span>
                <span className="block">Through Furniture</span>
              </p>
            </div>
          </a>
        </div>

      </div>
    </div>
  )
}

export default Arrival
